import { React, useEffect, useState } from 'react';
import { Grid, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { Add, Groups } from '@mui/icons-material';
import axios from 'axios';
import '../../App.css';
import AddEmployeeForm from './AddEmployeeForm';
import InternApprenticeMasterTable from '../table-data/InternApprenticeMasterTable';
import Popup from '../Popup';
import { setLoaderMessage } from '../../utils/loaderManager';

function ViewInternApprenticeEmployees() {
  const [openPopup, setOpenPopup] = useState(false);
  const [rows, setRows] = useState([]);
  const [showExEmployees, setShowExEmployees] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleCloseModal = () => {
    setOpenPopup(false);
    fetchApprenticeEmployees();
  };

  const fetchApprenticeEmployees = async () => {
    setLoading(true);
    setLoaderMessage('Loading intern/apprentice employees...');
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/apprentice-master/get-apprentice-employees`
      );
      const data = Array.isArray(res.data) ? res.data : res.data?.data || [];
      const hasTerminationDate = (e) => {
        const v = e?.date_of_termination;
        if (v == null) return false;
        const s = String(v).trim();
        return s !== '' && s.toLowerCase() !== 'null';
      };
      const filtered = showExEmployees
        ? data.filter(hasTerminationDate)
        : data.filter((e) => !hasTerminationDate(e));
      setRows(filtered);
    } catch (error) {
      setRows([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchApprenticeEmployees();
  }, [showExEmployees]);

  const handleShowCurrentEmployees = () => setShowExEmployees(false);
  const handleShowExEmployees = () => setShowExEmployees(true);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        margin: '6px',
        padding: '30px',
        fontWeight: '500px',
        marginTop: '-10px',
      }}
    >
      <Paper elevation={0} sx={{ width: '1500px' }}>
        <Grid className="form-title" style={{ marginBottom: '-73px' }} container spacing={2}>
          <Grid item>
            <Typography variant="h5" sx={{ textAlign: 'center', margin: 5 }}>
              View Intern/Apprentice Master
            </Typography>
          </Grid>
          <Grid item>
            <Groups style={{ marginLeft: '-30px' }} sx={{ width: 45, height: 45 }} />
          </Grid>
        </Grid>

        <Stack spacing={2} sx={{ alignItems: 'flex-end', marginRight: '30px' }}>
          <Button
            style={{ width: '260px' }}
            className="form-btn"
            variant="outlined"
            color="success"
            onClick={() => setOpenPopup(true)}
            startIcon={<Add sx={{ width: '24px', height: '24px' }} />}
            sx={{
              whiteSpace: 'nowrap',
              textTransform: 'none',
            }}
          >
            Add New Intern/Apprentice
          </Button>
          <Stack direction="row" spacing={2} style={{ marginBottom: '-15px' }}>
            <Button
              style={{ width: '250px' }}
              variant={showExEmployees ? 'outlined' : 'contained'}
              color="primary"
              onClick={handleShowCurrentEmployees}
              sx={{
                whiteSpace: 'nowrap',
                textTransform: 'none',
              }}
            >
              View Current Intern/Apprentice
            </Button>
            <Button
              style={{ width: '250px' }}
              variant={showExEmployees ? 'contained' : 'outlined'}
              color="info"
              onClick={handleShowExEmployees}
              sx={{
                whiteSpace: 'nowrap',
                textTransform: 'none',
              }}
            >
              View Ex Intern/Apprentice
            </Button>
          </Stack>
        </Stack>

        <form autoComplete="off" onSubmit={handleSubmit}>
          <Stack spacing={2} sx={{ margin: '30px' }}>
            <InternApprenticeMasterTable rows={rows} loading={loading} onRefresh={fetchApprenticeEmployees} />
          </Stack>
        </form>

        <Popup
          title="Add New Intern/Apprentice"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          maxWidth="sm"
          fullWidth={false}
          sx={{
            '& .MuiPaper-root': {
              width: '400px',
              maxWidth: '400px',
            },
          }}
        >
          <AddEmployeeForm fetch_id={9999} onCloseModal={handleCloseModal} hideStatutory={true} />
        </Popup>
      </Paper>
    </Box>
  );
}

export default ViewInternApprenticeEmployees;

